import { getRequest, postRequest } from '../utils/axios';
import { buildUrlParams } from '../utils/urls';

export const videosService = {
  listVideos: (params, onSuccess, onError) => {
    const url = '/api/v1/videos/' + buildUrlParams(params);
    getRequest(
      url,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response),
    );
  },

  createVideo: (data, onSuccess, onError) => {
    postRequest(
      '/api/v1/videos/',
      data,
      (response) => onSuccess?.(response.data),
      (error, response) => onError?.(error, response),
    );
  },

  getVideo: (hash, onSuccess, onError) => {
    getRequest(
      `/api/v1/videos/${hash}/`,
      (response) => onSuccess?.(response.data),
      (error, response) => onError?.(error, response),
    );
  },
};
